export const EVENT_VERSION = '1.1';
export const SYSTEM = 'player';